import ComingSoonPage from "../components/ComingSoon";

const Customers = () => {
  return <ComingSoonPage />;
};

export default Customers;
